import {
  Table,
} from '@mantine/core';
import {
  createFileRoute,
  useParentMatches,
} from '@tanstack/react-router';
import {
  useState,
} from 'react';

import styles from '#features/scout/DigitalAssistants/ActivityStatement.module.scss';
import {
  reportWithIdSchema,
  type ReportWithId,
} from '#features/scout/Schema/Reports.schema';
import NoReportFound from '#src/components/errors/NoReportFound';
export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/activityStatement',
)({
  beforeLoad: () => {
    return {
      crumb: 'Activity Statement',
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const {
    abn,
  } = Route.useParams();
  const parentMatches = useParentMatches();
  const reportData: ReportWithId = parentMatches.at(-1)?.loaderData;
  // console.debug(reportData);
  const {
    clients,
    activityStatement,
    codes,
  } = reportData;
  if (!clients) {
    throw new Error('Clients unknown');
  }
  const tables: any[] = activityStatement?.find(as => as.abn === abn)?.rows?.flat(1) ?? [];
  if (tables.length === 0) {
    return (
      <NoReportFound />
    );
  }
  const [
    startPeriod,
    setStartPeriod,
  ] = useState(0);
  function checkRow(rows, code) {
    for (let row of rows) {
      if (row) {
        if (row[`v${code}`]?.length > 0) {
          return row[`v${code}`].length;
        }
      } else {
        return 0;
      }
    }
    return 0;
  }

  function previousPageHandler() {
    if (startPeriod > 0) {
      setStartPeriod(startPeriod - 1);
    }
  }

  function nextPageHandler() {
    if (startPeriod < (tables.length - 4)) {
      setStartPeriod(startPeriod + 1);
    }
  }
  const months = tables.slice(startPeriod, startPeriod + 4);
  const tableData = {
    // caption: 'Client reports requested',
    head: [
      'Code',
      'Description',
      ...months.map(monthData => monthData.month),
    ],
    body: codes.map((code, rowIndex) => {
      return {
        id: rowIndex,
        columns: [
          code.code,
          code.description,
          ...months.map((row, cellIndex) => row[`v${code.code}`]),
        ],
      };
    }),
  };

  const tableRows = tableData.body.map((row, rowIndex) => (
    <Table.Tr
      key={ rowIndex }
      className={ styles.tableRow }
    >
      { row.columns.map((cell, cellIndex) => (
        <Table.Td
          key={ cellIndex }
        >
          { cell }
        </Table.Td>
      )) }
    </Table.Tr>
  ));
  const tableHeader = (rowKey: string) => (
    <Table.Tr
      key={ rowKey }
    >
      { tableData.head.map((col, colIndex) => (
        <Table.Td
          key={ colIndex }
        >
          { col }
        </Table.Td>
      )) }
    </Table.Tr>
  );

  return (
    <>
      <Table.ScrollContainer
        className={ styles.tableContainer }
        type="native"
        minWidth={ 500 }
      >
        <Table
          classNames={ {} }
          // data={tableData}
          verticalSpacing="sm"
          horizontalSpacing="lg"
          striped="odd"
          stripedColor="oklch(1 0 0 /0.05)"
          highlightOnHoverColor="primary.9"
          highlightOnHover
          stickyHeader
          withColumnBorders
          tabularNums
        >
          <Table.Thead>{ tableHeader('activity-statements-table-header') }</Table.Thead>
          <Table.Tbody>{ tableRows }</Table.Tbody>
          { /* <Table.Tfoot>{tableHeader("requests-table-footer")}</Table.Tfoot> */ }
        </Table>
      </Table.ScrollContainer>
    </>
  );
}
